import { render } from "./TalkFileUpload.vue?vue&type=template&id=a11d0cda&scoped=true"
import script from "./TalkFileUpload.vue?vue&type=script&lang=js"
export * from "./TalkFileUpload.vue?vue&type=script&lang=js"

import "./TalkFileUpload.vue?vue&type=style&index=0&id=a11d0cda&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1770878715/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11d0cda"]])

export default __exports__